
import { Component, Prop, Vue } from "vue-property-decorator";
import { migrateUnit, searchProductNumber } from "@/api/product-number";

@Component({
  name: "ProductNumberUnitMove",
})
export default class extends Vue {
  @Prop({ default: "" }) private productNumberId!: string;
  @Prop({ default: "" }) private type!: string;
  @Prop({ default: "" }) private typeNumber!: string;
  @Prop({ default: "" }) private number!: string;
  @Prop({ default: "" }) private typeId!: string;
  @Prop({ default: "" }) private productName!: string;
  @Prop({ default: "" }) private productId!: string;
  @Prop({ default: "" }) private customerId!: string;

  private targetSnId = "";
  private productNumberList = [];

  created() {
    searchProductNumber(
      {
        pageNumber: 0,
        pageSize: 9999999,
        customerId: this.customerId
      },
      this.productId
    ).then((res: any) => {
      this.productNumberList = res.list;
    });
  }

  private submit() {
    if (!this.targetSnId) {
      this.$message.error("请选择目标S/N");
      return;
    }
    let data = {
      number: this.typeNumber,
      typeId: this.typeId,
      productNumberId: this.productNumberId,
      targetSnId: this.targetSnId,
    };

    migrateUnit(data).then(() => {
      this.$message.success("迁移成功");
      this.$emit("cancel");
    });
  }

  private cancel() {
    this.$emit("cancel");
  }
}
